import './Auth.scss';
import { ReactElement } from 'react';
import { AuthContainer } from '../../modules/auth/containers/AuthContainer';
import { ResendConfirmEmailContainer } from '../../modules/auth/containers/ResendConfirmEmailContainer';

export const ResendConfirmationEmailView = (): ReactElement => (
  <AuthContainer>
    <ResendConfirmEmailContainer />
  </AuthContainer>
);
